import React from 'react';
import classNames from 'classnames';
import styled, { css } from 'styled-components';

// constants
import { spacing } from '../../style';
import DotsLoader from '../dots-loader';
import { variants, sizes } from './style';

// assets
import uploadFileIcon from './upload-file-icon.png';

interface DropzoneAreaProps {
  className?: string;
  isLoading?: boolean;
  children?: React.ReactNode;
  disabled?: boolean;
  variant?: keyof typeof variants;
  size?: keyof typeof sizes;
  round?: boolean;
  padding?: keyof typeof spacing;
  flexDirection?: 'row' | 'column';
  justifyContent?: 'center' | 'flex-start' | 'flex-end' | 'space-between' | 'space-around' | 'space-evenly';
}
const DropzoneAreaComponent = ({ className, isLoading, children, disabled }: DropzoneAreaProps) => (
  <div className={classNames(className, { disabled: disabled || isLoading })} data-testid={'file-upload-dropzone-area'}>
    {isLoading && (
      <div className={'loader-holder'}>
        <DotsLoader size={'md'} />
      </div>
    )}
    <div className={classNames('inner-container', { 'is-hidden': isLoading })}>{children}</div>
  </div>
);

const StyledDropzoneArea = styled(DropzoneAreaComponent)<DropzoneAreaProps>`
  padding: ${props => spacing[props.padding || 'md']};
  ${props => variants[props.variant || 'gray100']};

  transition: 0.2s;
  border-radius: 4px;
  cursor: pointer;
  position: relative;

  .loader-holder {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  &,
  .inner-container {
    height: ${props => sizes[props.size || 'auto']?.height || 'auto'};
    ${props =>
      props.round &&
      css`
        border-radius: 100%;
      `};
    display: flex;
    flex-direction: ${props => props.flexDirection || 'column'};
    justify-content: ${props => props.justifyContent || 'center'};
    align-items: center;
    &.is-hidden {
      opacity: 0;
    }
  }

  &.disabled {
    cursor: not-allowed;
    opacity: 0.8;
    * {
      cursor: not-allowed;
      opacity: 0.9;
      pointer-events: none;
    }
  }
`;

const DropzoneArea = (props: DropzoneAreaProps) => <StyledDropzoneArea {...props} />;
DropzoneArea.Image = () => <img alt={'upload'} src={uploadFileIcon} width={100} />;

export default DropzoneArea;
